import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';

import classNames from 'classnames/bind';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import useEventsSubscription from 'shared_DEPRECATED/hooks/useEventsSubscription';

import { ChatHeader } from 'features/chat/components';
import { ChatBody } from 'features/chat/components/ChatBody';
import { ChatAttachmentsProvider } from 'features/chat/context/chatAttachments';

import { CHAT_OPEN_EVENT } from '../config';
import { useChatMessagesContext } from '../context/chatMessages';
import styles from 'features/chat/components/Chat.module.css';

const cx = classNames.bind(styles);

export function Chat({
  open,
  toggleOpen,
}: {
  open: boolean;
  toggleOpen: () => void;
}) {
  const { setValue } = useFormContext();
  const wrapClassName = cx('chat', { 'chat--open': open });
  const { setDraftMessageId } = useChatMessagesContext();
  const { state, pathname } = useLocation();
  const navigate = useNavigate();

  const events = useMemo(() => [[CHAT_OPEN_EVENT, toggleOpen]], [toggleOpen]);

  // @ts-ignore
  useEventsSubscription(events);

  useEffect(() => {
    if (state?.draftMessageId) {
      setDraftMessageId(state.draftMessageId);
      navigate(pathname, {
        replace: true,
        state: { ...state, draftMessageId: null, openChat: false },
      });
    }
  }, [navigate, setDraftMessageId, pathname, state]);

  // Handle message from location state
  useEffect(() => {
    if (state?.message) {
      setValue('text', state.message);
      navigate(pathname, {
        replace: true,
        state: { ...state, message: '', openChat: false },
      });
    }
  }, [navigate, state, pathname, setValue]);

  return (
    <div className={wrapClassName}>
      <ChatAttachmentsProvider>
        <Flex flexDirection="column" alignItems="stretch" height="100%">
          <ChatHeader open={open} toggleOpen={toggleOpen} />
          {open && <ChatBody />}
        </Flex>
      </ChatAttachmentsProvider>
    </div>
  );
}
